<script lang="ts" setup>
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Loading from 'assets/images/loading.svg?component'
import { useGraphQuery } from '~/utils/graphql/client'
import { RegisterCommunicationSubscriptionsDocument } from '~/utils/generated/graphql'

const email = ref()
const disabled = ref(false)
const success = ref(false)
const error = ref(false)

const props = defineProps<{
  footer?: boolean
}>()

async function subscribe() {
  error.value = false
  disabled.value = true
  try {
    if (!email.value?.value) throw new Error('Missing Email')
    if (!email.value?.value.includes('@')) throw new Error('Invalid Email')

    await useGraphQuery(RegisterCommunicationSubscriptionsDocument, { email: email.value?.value, source: props.footer ? 'footer-newsletter' : 'newsletter' })
    email.value = null
    success.value = true
  }
  catch (e) {
    error.value = true
    console.log('error signing up', e)
  }
  finally {
    disabled.value = false
  }
}
</script>

<template>
  <div :class="(footer ? '' : 'md:flex w-full items-center')">
    <h4 :class="(footer ? 'h4 mb-6' : 'flex h5 mt-0 mb-2 md:m-0 text-[#2A6D99] grow')">
      {{ $t('latestResourceWeekly') }}
    </h4>
    <div
      v-if="!success"
      class="flex shrink-0 gap-4"
    >
      <input
        ref="email"
        type="text"
        class="flex grow md:grow-0 md:w-[300px] p-2 pt-2.5 border-none focus:outline-none text-blurple-950 rounded-lg placeholder-neutral-400 items-center font-sans"
        :placeholder="$t('emailAddress')"
      >
      <PButton
        id="digest-signup"
        :disabled="disabled"
        :class="(footer ? 'bg-blurple-950' : 'bg-[#2A6D99]') + ' flex items-center text-white ps-4 pe-4 min-w-24 justify-items-center rounded-md'"
        :click="subscribe"
      >
        <Loading
          v-if="disabled"
          class="stroke-white w-4 h-4 animate-spin"
        />
        <span v-else>
          {{ $t('subscribe') }}
        </span>
      </PButton>
    </div>
    <div
      v-else
      class="h4"
    >
      {{ $t('thanksForSubscribing') }}
    </div>
    <div
      v-if="error"
      class="text-red-500 mx-4 my-2"
    >
      {{ $t('errorSubscribing') }}
    </div>
  </div>
</template>
